export const trackPhoneConversion = () => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-18351825475/05NbCMDyt9wcEMPE6q5E",
      value: 1.0,
      currency: "UAH",
    });
  }
};